import { COUNTRIES } from '../../config/countries-data'

export type StripeAddress = {
  name: string
  firstName?: string
  lastName?: string
  address: {
    line1: string
    line2: string | null
    city: string
    state: string
    postal_code: string
    country: string
  }
  phone?: string
}

// Stripe reveals only these four before confirm (ExpressCheckoutPartialAddress).
export function createPartialAddressFromStripeFormat({
  country,
  city,
  state,
  postal_code: zipCode,
}: {
  country: string
  city: string
  state: string
  postal_code: string
}) {
  return {
    countryId: Object.values(COUNTRIES).find((c) => c.code === country)?.id,
    city,
    state,
    zipCode,
  }
}

// Conversion between stripe format and our address format.
// Stripe format: https://stripe.com/docs/js/payment_request/events/on_shipping_option_change
// Our format is according to countries-data.js - ADDRESS_INPUT_FIELDS
export function createAddressFromStripeFormat(
  stripeAddressFormat: StripeAddress
) {
  const { name, address, phone } = stripeAddressFormat
  return {
    ...createPartialAddressFromStripeFormat(address),
    fullName: name,
    phoneNumber: phone ?? '',
    street: address.line1,
    address_2: address.line2 || '',
  }
}

// Conversion between our address format and stripe format.
// Our format is according to countries-data.js - ADDRESS_INPUT_FIELDS
// Stripe format: https://stripe.com/docs/js/payment_request/events/on_shipping_option_change
export function convertAddressToStripeFormat({
  fullName = '',
  street = '',
  address_2: line2 = '',
  city = '',
  state = '',
  zipCode = '',
  countryId = '',
  phoneNumber = '',
}): StripeAddress {
  return {
    name: fullName,
    address: {
      line1: street,
      line2,
      city,
      state,
      postal_code: zipCode,
      country:
        Object.values(COUNTRIES).find((c) => c.id === countryId)?.code || '',
    },
    phone: phoneNumber,
  }
}

export function getPhoneFieldOptions({
  isPhoneFieldShown = false,
  isPhoneRequired = false,
}): {
  fields?: {
    phone?: 'always' | 'never' | 'auto'
  }
  validation?: {
    phone?: {
      required: 'always' | 'never' | 'auto'
    }
  }
} {
  if (isPhoneFieldShown) {
    return {
      fields: {
        phone: 'always',
      },
      validation: {
        phone: {
          required: isPhoneRequired ? 'always' : 'never',
        },
      },
    }
  }
  return {}
}
